"use client";
import React, { useEffect } from "react";
import Header from "./Header";
import Footer from "./Footersection";

const ContactUs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="flex flex-col min-h-screen">
      <Header />

      <main className="flex flex-col items-center flex-1 px-4 sm:px-10 py-10 bg-neutral-50 w-full max-w-5xl mx-auto gap-8">
        <h1 className="text-2xl sm:text-3xl font-bold text-center text-gray-800 mb-6">
          Contact Us
        </h1>

        <div className="bg-white rounded-2xl shadow-lg p-6 sm:p-8 w-full">
          <div className="flex flex-col space-y-6 text-gray-700 text-base sm:text-lg">

            <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center">
              <span className="font-semibold">Website:</span>
              <a
                href="https://onestopweddingdresses.com"
                className="text-blue-600 hover:underline break-all mt-1 sm:mt-0"
              >
                onestopweddingdresses.com
              </a>
            </div>

            <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center">
              <span className="font-semibold">Email:</span>
              <a
                href="mailto:support@onestopweddingdresses.com"
                className="text-blue-600 hover:underline break-all mt-1 sm:mt-0"
              >
                support@onestopweddingdresses.com
              </a>
            </div>

            <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center">
              <span className="font-semibold">Phone:</span>
              <a
                href="tel:+918333922444"
                className="text-blue-600 hover:underline mt-1 sm:mt-0"
              >
                +91 83339 22444
              </a>
            </div>

            <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center">
              <span className="font-semibold">Support Hours:</span>
              <span className="mt-1 sm:mt-0">Mon–Sat, 10:00 AM – 7:00 PM IST</span>
            </div>

            <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center">
              <span className="font-semibold">Address:</span>
              <span className="mt-1 sm:mt-0">Vizianagaram, Andhra Pradesh, India</span>
            </div>

          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default ContactUs;
